import { InputField } from 'components/molecules'
import { Label } from 'reactstrap'

const ProductPriceFilterField = () => (
  <>
    <Label className='filter-title font-weight-bold pb-2'>
      { 'PRICE' }
    </Label>
    <InputField
      name='price_from'
      label='Min'
      placeholder='0'
      type='number'
    />
    <InputField
      name='price_to'
      label='Max'
      placeholder='100000000'
      type='number'
    />
  </>
)

export default ProductPriceFilterField
